export var randomInt = function randomInt(_ref) {
  var _ref$min = _ref.min,
      min = _ref$min === undefined ? 1 : _ref$min,
      _ref$max = _ref.max,
      max = _ref$max === undefined ? 10 : _ref$max;
  return Math.floor(Math.random() * (max - min + 1)) + min;
};